module.exports = __webpack_public_path__ + "892d2051942245b23b92ae6d28ff4f8b.pdf";